<template>
  <div :class="width" class="p-1">
    <div class="ssc-wrapper bg-gray-700">
      <div class="h-64 shaddow">
        <div class="ssc-square mb w-full h-64"></div>
      </div>
      <div class="bg-secondary p-2 flex flex-col h-28">
        <div class="w-16 mb-2">
          <div class="ssc-line"></div>
        </div>
        <div class="w-28">
          <div class="ssc-line"></div>
        </div>
        <div class="flex-1" />
        <div class="mt-2 pb-2">
          <ul class="flex justify-between">
            <li class="xs:mr-2 mr-0 w-10 h-10">
              <div class="ssc-circle"></div>
            </li>
            <li class="w-10 h-10">
              <div class="ssc-circle"></div>
            </li>
            <li class="hidden xs:block flex-1" />
            <li class="w-10 h-10">
              <div class="ssc-circle"></div>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "skeleton-card-explore-movie",
  props: {
    width: {
      type: String,
      default: "w-48"
    }
  }
};
</script>
